import React, { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Heart, X } from "lucide-react";

const IMPRESSUM = `
IMPRESSUM

Angaben gemäß § 5 TMG:

Al Kasbah Lebensmittel
Inhaber: Abdelghani El Dahabi
Schmeerstraße 27-28
06108 Halle (Saale)
Deutschland

Kontakt:
Telefon: +49 179 827 2922
E-Mail: a_eldahabi@yahoo.de


Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:
Abdelghani El Dahabi
Al Kasbah Lebensmittel
Schmeerstraße 27-28, 06108 Halle (Saale)

Streitschlichtung:
Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
https://ec.europa.eu/consumers/odr
Unsere E-Mail-Adresse finden Sie oben im Impressum.
Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
Verbraucherschlichtungsstelle teilzunehmen.

Haftung für Inhalte:
Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen
Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind
wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf
eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder
Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
hiervon unberührt.

Haftung für Links:
Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
Anbieter oder Betreiber der Seiten verantwortlich.

Urheberrecht:
Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.

Bildnachweise:
Verwendete Bilder stammen aus eigenen Aufnahmen, von Pexels (pexels.com),
Pixabay (pixabay.com) sowie aus KI-generierten Quellen. Die jeweiligen
Lizenzbedingungen wurden beachtet.
`;
const DATENSCHUTZ = `
DATENSCHUTZERKLÄRUNG

1. Datenschutz auf einen Blick

Allgemeine Hinweise:
Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert
werden können.

Datenerfassung auf dieser Website:
Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber:

Al Kasbah Lebensmittel
Abdelghani El Dahabi
Schmeerstraße 27-28, 06108 Halle (Saale)
E-Mail: a_eldahabi@yahoo.de
Telefon: +49 179 827 2922

2. Hosting

Diese Website wird bei Netlify gehostet. Anbieter ist Netlify, Inc.,
512 2nd Street, Suite 200, San Francisco, CA 94107, USA (nachfolgend "Netlify").

Wenn Sie unsere Website besuchen, erfasst Netlify verschiedene Logfiles
inklusive Ihrer IP-Adresse. Details entnehmen Sie der Datenschutzerklärung
von Netlify: https://www.netlify.com/privacy/

Die Verwendung von Netlify erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
Wir haben ein berechtigtes Interesse an einer möglichst zuverlässigen und
sicheren Darstellung unserer Website.

Datenübermittlung in die USA:
Netlify verarbeitet Daten auch in den USA. Netlify ist unter dem EU-US Data
Privacy Framework (DPF) zertifiziert, welches einen angemessenen Datenschutz
gemäß Art. 45 DSGVO gewährleistet. Weitere Informationen:
https://www.dataprivacyframework.gov/

Auftragsverarbeitung:
Wir haben mit Netlify einen Vertrag zur Auftragsverarbeitung (Data Processing
Addendum) nach Art. 28 DSGVO geschlossen.

3. Allgemeine Hinweise und Pflichtinformationen

Datenschutz:
Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr
ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend
der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.

Hinweis zur verantwortlichen Stelle:
Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:

Al Kasbah Lebensmittel
Abdelghani El Dahabi
Schmeerstraße 27-28, 06108 Halle (Saale)
Telefon: +49 179 827 2922
E-Mail: a_eldahabi@yahoo.de

SSL- bzw. TLS-Verschlüsselung:
Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte
Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://"
auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.

4. Datenerfassung auf dieser Website

Server-Log-Dateien:
Der Provider der Seiten (Netlify) erhebt und speichert automatisch Informationen
in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt.
Dies sind:
- Browsertyp und Browserversion
- verwendetes Betriebssystem
- Referrer URL
- Hostname des zugreifenden Rechners
- Uhrzeit der Serveranfrage
- IP-Adresse

Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien
Darstellung und der Optimierung seiner Website.

Lokale Speicherung (localStorage):
Zur Bereitstellung bestimmter Funktionen speichert diese Website Daten im
lokalen Speicher Ihres Browsers (localStorage). Konkret werden gespeichert:
- Ihre gewählte Sprache (Deutsch, Englisch, Arabisch)
- Die von Ihnen ausgewählten Artikel für eine Vorbestellung

Diese Daten verbleiben ausschließlich in Ihrem Browser und werden nicht an uns
oder Dritte übertragen. Die Rechtsgrundlage ist § 25 Abs. 2 Nr. 2 TTDSG, da die
Speicherung für die vom Nutzer ausdrücklich gewünschte Funktion unbedingt
erforderlich ist. Sie können die gespeicherten Daten jederzeit über die
Einstellungen Ihres Browsers löschen.

Vorbestellung via WhatsApp:
Auf dieser Website können Sie eine unverbindliche Vorbestellung aufgeben.
Die von Ihnen eingegebenen Daten (Name, gewünschte Produkte, gewünschter
Abholzeitpunkt) werden nicht auf unseren Servern gespeichert, sondern
ausschließlich in eine vorformulierte WhatsApp-Nachricht eingefügt, die Sie
anschließend manuell über Ihre eigene WhatsApp-Anwendung an uns senden.

Anbieter von WhatsApp ist die WhatsApp Ireland Limited, 4 Grand Canal Square,
Grand Canal Harbour, Dublin 2, Irland (Mutterkonzern: Meta Platforms, Inc., USA).

Mit dem Absenden der Nachricht an uns werden Ihre Daten durch WhatsApp
verarbeitet. WhatsApp kann dabei auch Daten in die USA übermitteln.
Meta Platforms ist unter dem EU-US Data Privacy Framework zertifiziert.

Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung
(Art. 6 Abs. 1 lit. a DSGVO) sowie zur Anbahnung und Durchführung eines
Vertrags (Art. 6 Abs. 1 lit. b DSGVO). Sie erteilen die Einwilligung durch
Aktivierung der Checkbox vor dem Absenden.

Weitere Informationen zur Datenverarbeitung durch WhatsApp finden Sie in der
Datenschutzerklärung von WhatsApp:
https://www.whatsapp.com/legal/privacy-policy-eu

Ihre bei uns per WhatsApp eingegangenen Nachrichten speichern wir, solange dies
zur Bearbeitung Ihrer Anfrage sowie zur Erfüllung etwaiger gesetzlicher
Aufbewahrungspflichten erforderlich ist, längstens jedoch 6 Monate nach
Abschluss des Vorgangs.

5. Einbindung von OpenStreetMap

Auf unserer Website binden wir Kartenmaterial des Dienstes "OpenStreetMap" ein.
Anbieter ist die OpenStreetMap Foundation (OSMF), St John's Innovation Centre,
Cowley Road, Cambridge, CB4 0WS, Vereinigtes Königreich.

Die Karte wird erst geladen, nachdem Sie aktiv auf die Schaltfläche "Karte laden"
geklickt haben. Erst durch diesen Klick werden Daten (insbesondere Ihre
IP-Adresse) an die Server von OpenStreetMap übertragen. Vor dem Klick findet
keine Übertragung statt.

Die Rechtsgrundlage für die Datenverarbeitung nach erfolgtem Klick ist Ihre
Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO sowie § 25 Abs. 1 TTDSG.

Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der
Datenschutzerklärung von OpenStreetMap:
https://wiki.osmfoundation.org/wiki/Privacy_Policy

6. Schriftarten

Diese Website verwendet lokal gehostete Schriftarten ("Outfit", "DM Sans",
"Amiri", "Inter"). Es werden keine Verbindungen zu externen Font-Diensten
wie Google Fonts aufgebaut. Die Schriftarten werden ausschließlich von
unserem eigenen Server ausgeliefert.

7. Ihre Rechte

Sie haben jederzeit das Recht auf:
- Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)
- Berichtigung unrichtiger Daten (Art. 16 DSGVO)
- Löschung Ihrer Daten (Art. 17 DSGVO)
- Einschränkung der Verarbeitung (Art. 18 DSGVO)
- Datenübertragbarkeit (Art. 20 DSGVO)
- Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)
- Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft
  (Art. 7 Abs. 3 DSGVO)

Zur Ausübung Ihrer Rechte wenden Sie sich bitte an die im Impressum genannte
E-Mail-Adresse.

Beschwerderecht bei der zuständigen Aufsichtsbehörde:
Landesbeauftragter für den Datenschutz Sachsen-Anhalt
Otto-von-Guericke-Straße 34a, 39104 Magdeburg
Tel.: +49 391 81803-0
Fax: +49 391 81803-33
E-Mail: poststelle@lfd.sachsen-anhalt.de

Stand: April 2026
`;
const AGB = `
ALLGEMEINE GESCHÄFTSBEDINGUNGEN (AGB)

Stand: April 2026

§ 1 Geltungsbereich
Diese Allgemeinen Geschäftsbedingungen gelten für alle Vorbestellungen, die
über die Website al-kasbah.de oder per WhatsApp beim Betreiber aufgegeben werden:

Al Kasbah Lebensmittel
Inhaber: Abdelghani El Dahabi
Schmeerstraße 27-28, 06108 Halle (Saale)
E-Mail: a_eldahabi@yahoo.de
Telefon: +49 179 827 2922

§ 2 Vorbestellung & Abholung
1. Die über diese Website mögliche Vorbestellung ist ein unverbindlicher
   Wunsch des Kunden. Ein Vertrag kommt erst durch ausdrückliche Bestätigung
   des Betreibers per WhatsApp zustande.

2. Es handelt sich ausschließlich um einen Abholservice.
   Eine Lieferung wird nicht angeboten.

3. Der Kunde verpflichtet sich, die vorbestellte Ware zum vereinbarten
   Zeitpunkt abzuholen. Bei Nichtabholung ohne vorherige Stornierung
   behalten wir uns vor, anfallende Kosten in Rechnung zu stellen.

§ 3 Preise und Verfügbarkeit
1. Alle Preise sind Endpreise inkl. gesetzlicher Mehrwertsteuer.

2. Preise können je nach Saison und Verfügbarkeit variieren.
   Die aktuellen Preise sind in unserem Laden einsehbar.

3. Die Verfügbarkeit der Produkte kann nicht garantiert werden.
   Bei Nichtverfügbarkeit werden wir den Kunden umgehend informieren.

§ 4 Stornierung
Vorbestellungen können bis 12 Stunden vor dem vereinbarten Abholtermin
kostenlos storniert werden. Spätere Stornierungen können zu Kosten führen.

§ 5 Widerrufsrecht
Da es sich bei den angebotenen Waren überwiegend um verderbliche Frischwaren
(insbesondere Fleisch und Lebensmittel) handelt und die Ware ausschließlich
vor Ort im Geschäft abgeholt wird, besteht gemäß § 312g Abs. 2 Nr. 2 und Nr. 4
BGB kein gesetzliches Widerrufsrecht.

§ 6 Gewährleistung
Es gelten die gesetzlichen Gewährleistungsrechte. Da es sich um Frischwaren
handelt, sind Reklamationen unmittelbar bei der Abholung geltend zu machen.

§ 7 Informationen zu Allergenen und Zutaten
Informationen zu Allergenen, Zutaten und Herkunft unserer Produkte gemäß
Lebensmittelinformationsverordnung (LMIV) erhalten Sie auf Anfrage im
Geschäft oder per WhatsApp.

§ 8 Anwendbares Recht und Gerichtsstand
Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des
UN-Kaufrechts.

Gerichtsstand ist Halle (Saale), soweit der Kunde Kaufmann, juristische Person
des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist.
Für Verbraucher gelten die gesetzlichen Gerichtsstände.

§ 9 Schlussbestimmungen
Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt
die Wirksamkeit der übrigen Bestimmungen unberührt.
`;

export default function Footer() {
  const { t } = useLanguage();
  const [openDoc, setOpenDoc] = useState(null);
  React.useEffect(() => {
  const handler = (e) => setOpenDoc(e.detail);
  window.addEventListener("openLegalDoc", handler);
  return () => window.removeEventListener("openLegalDoc", handler);
}, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navLinks = [
    { key: "home", id: "home" },
    { key: "about", id: "about" },
    { key: "products", id: "products" },
    { key: "gallery", id: "gallery" },
    { key: "contact", id: "contact" },
  ];

  const getDoc = () => {
    if (openDoc === "impressum") return { title: "Impressum", content: IMPRESSUM };
    if (openDoc === "datenschutz") return { title: "Datenschutzerklärung", content: DATENSCHUTZ };
    if (openDoc === "agb") return { title: "AGB", content: AGB };
    return null;
  };

  const doc = getDoc();

  return (
    <>
      <footer data-testid="footer" className="text-white" style={{ backgroundColor: "#0A0A0A" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">

            {/* Brand */}
            <div>
              <h3 className="font-heading text-2xl font-bold mb-4" style={{ color: "#D4AF37" }}>
                Al-Kasbah
              </h3>
              <p className="text-sm text-neutral-400 leading-relaxed">
                Premium Fresh Meat, Every Day.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading font-semibold text-sm uppercase tracking-wider mb-4 text-white">
                {t("footer.quickLinks")}
              </h4>
              <ul className="space-y-2">
                {navLinks.map((link) => (
                  <li key={link.key}>
                    <button
                      data-testid={`footer-link-${link.key}`}
                      onClick={() => scrollTo(link.id)}
                      className="text-sm text-neutral-400 hover:text-[#D4AF37] transition-colors"
                    >
                      {t(`nav.${link.key}`)}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Business Hours */}
            <div>
              <h4 className="font-heading font-semibold text-sm uppercase tracking-wider mb-4 text-white">
                {t("footer.hours")}
              </h4>
              <ul className="space-y-2 text-sm text-neutral-400">
                <li className="flex justify-between">
                  <span>{t("footer.monFri")}</span>
                  <span>08:30 - 20:00</span>
                </li>
                <li className="flex justify-between">
                  <span>{t("footer.saturday")}</span>
                  <span>08:30 - 20:00</span>
                </li>
                <li className="flex justify-between">
                  <span>{t("footer.sunday")}</span>
                  <span className="text-[#8B0000]">{t("footer.closed")}</span>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-heading font-semibold text-sm uppercase tracking-wider mb-4 text-white">
                {t("footer.contact")}
              </h4>
              <ul className="space-y-2 text-sm text-neutral-400">
                <li>
                  <a href="tel:+491798272922" className="hover:text-[#D4AF37] transition-colors">
                    +49 179 827 2922
                  </a>
                </li>
                
                <li>Schmeerstraße 27-28, 06108 Halle (Saale)</li>
              </ul>
            </div>

          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-800">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-neutral-500">
              &copy; {new Date().getFullYear()} Al-Kasbah. All rights reserved.
            </p>

            {/* Legal Links */}
            <div className="flex items-center gap-4">
              <button
                onClick={() => setOpenDoc("impressum")}
                className="text-xs text-neutral-500 hover:text-[#D4AF37] transition-colors"
              >
                Impressum
              </button>
              <span className="text-neutral-700">·</span>
              <button
                onClick={() => setOpenDoc("datenschutz")}
                className="text-xs text-neutral-500 hover:text-[#D4AF37] transition-colors"
              >
                Datenschutz
              </button>
              <span className="text-neutral-700">·</span>
              <button
                onClick={() => setOpenDoc("agb")}
                className="text-xs text-neutral-500 hover:text-[#D4AF37] transition-colors"
              >
                AGB
              </button>
            </div>

            
          </div>
        </div>
      </footer>

      {/* Legal Document Modal */}
      {doc && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center px-4"
          style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
          onClick={(e) => e.target === e.currentTarget && setOpenDoc(null)}
        >
          <div
            className="relative w-full max-w-2xl bg-white rounded-sm shadow-2xl"
            style={{ maxHeight: "85vh", overflowY: "auto" }}
          >
            {/* Modal Header */}
            <div
              className="sticky top-0 px-6 py-4 flex items-center justify-between"
              style={{ backgroundColor: "#0A0A0A", borderBottom: "2px solid #D4AF37" }}
            >
              <h2 className="font-heading text-lg font-semibold text-white">
                {doc.title}
              </h2>
              <button
                onClick={() => setOpenDoc(null)}
                className="text-white/70 hover:text-white transition-colors"
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="px-6 py-6">
              <pre
                className="text-sm text-neutral-700 leading-relaxed whitespace-pre-wrap font-sans"
              >
                {doc.content}
              </pre>
            </div>
          </div>
        </div>
      )}
    </>
  );
}